var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
var SvgPackages = function (props) { return (_jsxs("svg", __assign({ width: 25, height: 26, viewBox: "0 0 25 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [_jsx("path", { d: "M20.833 2.583H4.167c-1.042 0-2.084.938-2.084 2.084v3.135c0 .75.448 1.396 1.042 1.76v11.771c0 1.146 1.146 2.084 2.083 2.084h14.584c.937 0 2.083-.938 2.083-2.084V9.563c.594-.365 1.042-1.01 1.042-1.76V4.666c0-1.146-1.042-2.084-2.084-2.084Zm-1.041 18.75H5.208V9.875h14.584v11.458Zm1.041-13.541H4.167V4.667h16.666v3.125Z", fill: "#424242" }), _jsx("path", { d: "M15.625 13h-6.25v2.083h6.25V13Z", fill: "#424242" })] }))); };
var Memo = memo(SvgPackages);
export default Memo;
//# sourceMappingURL=Packages.js.map